import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/40 mt-16 sm:mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 py-10 sm:py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="h-4 w-4 text-accent" />
            <span className="font-mono text-xs tracking-[0.32em] uppercase">The Shift</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
            Change your frequency. Change your reality. A digital philosophy for the becoming.
          </p>
        </div>
        <div>
          <div className="eyebrow mb-3">Experience</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shift-reader" className="hover:text-accent">The Shift Reader</Link></li>
            <li><Link to="/library" className="hover:text-accent">The Library</Link></li>
            <li><Link to="/journal" className="hover:text-accent">The Journal</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-3">Deepen</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/stories" className="hover:text-accent">Shift Stories</Link></li>
            <li><Link to="/community" className="hover:text-accent">Community</Link></li>
            <li><Link to="/founder" className="hover:text-accent" data-testid="footer-founder-link">Meet Tay</Link></li>
            <li><Link to="/membership" className="hover:text-accent">The Shift Room</Link></li>
          </ul>
        </div>
        <div className="col-span-2 md:col-span-1">
          <div className="eyebrow mb-3">Pillars</div>
          <ul className="space-y-2 text-xs font-mono uppercase tracking-widest text-muted-foreground">
            <li>Source</li>
            <li>Energy</li>
            <li>Frequency</li>
            <li>Timelines</li>
            <li>Consciousness</li>
          </ul>
        </div>
      </div>
      <div className="hairline">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[10px] sm:text-xs font-mono tracking-widest text-muted-foreground uppercase">
            © {new Date().getFullYear()} The Shift — All frequencies reserved
          </p>
          <p className="text-[10px] sm:text-xs font-mono tracking-widest text-muted-foreground italic">
            You are not stuck. You are shifting.
          </p>
        </div>
      </div>
    </footer>
  );
}
